export default __webpack_public_path__ + "static/media/water8.b85c3632.png";